module.exports = __webpack_public_path__ + "img/AssetManager.96e768e1.svg";